import KycKybUpdateSerializer from './-kyc-kyb-update';

export default KycKybUpdateSerializer.extend({
  include(request) {
    // UpdateProcess must be included whenever we POST or PATCH in order to check needs_review
    return request.method === 'POST' || request.method === 'PATCH' ? ['kycKybUpdateProcess'] : [];
  },
});
